import React from "react";
import { FaCirclePause, FaCirclePlay } from "react-icons/fa6";
import { useTranslation } from "react-i18next";

const WaitingValidate = ({ waiting, className = "" }) => {
    const { t } = useTranslation();
    return waiting ? (
        <FaCirclePause
            className={`lumen-glow-icon text-orange-400 ${className}`}
            title={t("waiting-list.indicator.waiting", { defaultValue: "Op wachtlijst" })}
        />
    ) : (
        // <FaCirclePlay
        //     className={`text-green-400 ${className}`}
        //     title={t("waiting-list.indicator.available", { defaultValue: "Ingedeeld" })}
        // />
        <></>
    );
};

export default WaitingValidate;
